import {getRouteApi} from "@tanstack/react-router";

export const serviceNotesRouteApi = getRouteApi("/_app/engineering/services/$serviceId/notes/");
